import { render, staticRenderFns } from "./NoticesView.vue?vue&type=template&id=cb914168"
import script from "./NoticesView.vue?vue&type=script&lang=ts"
export * from "./NoticesView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports